import NewColors from "../../themes/NewColors";

/** Amber banner + dark text (WCAG-friendly); not semantic `error.*` (those + disabled opacity read poorly). */
export const DUPLICATE_WARNING_BOX_SX = {
  fontWeight: 600,
  color: NewColors.text.primary,
  backgroundColor: "#FEF3C7",
  border: "1px solid",
  borderColor: "#B45309",
  p: 1.5,
  borderRadius: 1,
  pointerEvents: "none",
  cursor: "not-allowed",
  display: "flex",
  alignItems: "center",
  gap: 1,
  width: "100%",
  boxSizing: "border-box",
};

/** MUI dims disabled options (~0.38 opacity); duplicate-warning rows use disabled to block selection — undo for readability. */
export const DUPLICATE_WARNING_AUTOCOMPLETE_SX = {
  '& .MuiAutocomplete-option[aria-disabled="true"][data-duplicate-warning="true"]': {
    opacity: 1,
  },
};
